import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  AggregatedStatusResponse,
  AlarmTypeCollection,
  ClosedStatusCollectionResponse,
  DeviceRuleStatus,
  LatestStatusCollection,
  LatestStatusResponse,
  StatusEventCollectionResponse,
} from '@core/models';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  constructor(private readonly apiService: ApiService) {}

  getLatestStatus(device_id: string): Observable<LatestStatusResponse> {
    return this.apiService.get(`/alarm/latest/${device_id}`);
  }

  getLatestPartnerOverviewStatus(
    index: number,
    page_size: number,
  ): Observable<LatestStatusCollection> {
    const params = new HttpParams()
      .set('index', index.toString())
      .set('page_size', page_size.toString());
    return this.apiService.get(`/alarm/latest/all`, params);
  }

  getAlarmEvents(
    deviceId: string,
    index: number,
    page_size: number,
  ): Observable<StatusEventCollectionResponse> {
    const params = new HttpParams()
      .set('index', index.toString())
      .set('page_size', page_size.toString());
    return this.apiService.get(`/alarm/${deviceId}/events`, params);
  }

  getAlarmRules(deviceId: string): Observable<DeviceRuleStatus[]> {
    return this.apiService.get(`/alarm/rules/device/${deviceId}`);
  }

  addDeviceToAlarmRule(ruleName: string, deviceId: number): Observable<unknown> {
    return this.apiService.post(`/alarm/rules/${ruleName}/devices`, {
      device_id: deviceId,
      enabled: true,
    });
  }

  removeDeviceFromAlarmRule(ruleName: string, deviceId: number): Observable<unknown> {
    return this.apiService.delete(`/alarm/rules/${ruleName}/devices/${deviceId}`);
  }

  getClosedAlarmStatuses(deviceId: string): Observable<ClosedStatusCollectionResponse> {
    return this.apiService.get(`/alarm/latest/${deviceId}/closed`);
  }

  getAlarmTypes(): Observable<AlarmTypeCollection> {
    return this.apiService.get(`/alarm/alarm-types`);
  }

  closeAlarmStatus(deviceId: string, statusId?: string): Observable<unknown> {
    const url = statusId
      ? `/alarm/latest/${deviceId}/close?status_id=${encodeURIComponent(statusId)}`
      : `/alarm/latest/${deviceId}/close`;
    return this.apiService.patch(url);
  }

  resetDevice(deviceId: string): Observable<unknown> {
    return this.apiService.post(`/alarm/latest/${deviceId}/reset`, {});
  }

  getAllPartnerOverviewStatus(
    index: number,
    page_size: number,
  ): Observable<AggregatedStatusResponse[]> {
    const params = new HttpParams()
      .set('index', index.toString())
      .set('page_size', page_size.toString());
    return this.apiService.get(`/alarm/partner/all`, params);
  }
}
